
import axios from 'axios'

import BaseService from './BaseService'
import Enumeration from "../enumeration";
const Environment = require('../environments/environment.json')

const addAuction = (vehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/AddAuction/` + vehicleId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getMakes = (sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/Makes`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getModels = (makes, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/Models`, makes,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const searchAuctions = (searchRequest, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/Search`, searchRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getAuctionVehicle = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/GetAuctionVehicle/` + auctionId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const updateAuctionVehicle = (auctionVehicle, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/UpdateAuctionVehicle`, auctionVehicle, headers) )
			})
			.catch((error) =>
			{
				console.log(error)
				reject(error)
			})
	})
}

const updateAuction = (auction, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/UpdateAuctionDetail`, auction, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const cancelAuction = (auction, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/CancelAuction`, auction, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const updateAuctionPricing = (auction, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/UpdateAuctionPricing`, auction, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getAuctionTiers = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/GetAuctionTiers/` + auctionId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getAuctionTierMembers = (auctionTierId, userGroupId, parentEntityId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/GetAuctionTierMembers/` + auctionTierId + '/' + userGroupId + '/' + parentEntityId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getMemberActiveAuctions = (pageIndex, pageSize, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/GetMemberActiveAuctions/` + pageIndex + '/' + pageSize,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getMemberSearchViewModel = (auctionSearchRequest, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/GetMemberSearchViewModel`, auctionSearchRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getBusinessSearchViewModel = (auctionSearchRequest, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/GetBusinessSearchViewModel`, auctionSearchRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const memberAuctionSearch = (searchRequest, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/MemberSearch`, searchRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const memberSearchFilters = (sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/MemberSearchFilters`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const updateAuctionListPricing = (auctionSearchResults, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/UpdateListPricing`, auctionSearchResults, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addMemberBid = (auctionTierMemberId, bidAmount, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.put(`${Environment.apiUrl}/Auctions/AddMemberBid/` + auctionTierMemberId + `/` + bidAmount, null, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addMemberBuyNow = (auctionTierMemberId, auctionVehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.put(`${Environment.apiUrl}/Auctions/AddMemberBuyNow/` + auctionTierMemberId + `/` + auctionVehicleId, null, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const restartAuction = (restartRequest, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/RestartAuction`, restartRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getBidsAndOffersViewModel = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/GetBidsAndOffers/${auctionId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const confirmTierMemberBid = (entityId, entityTypeId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.put(`${Environment.apiUrl}/Auctions/ConfirmTierMemberBid/${entityId}/${entityTypeId}`, null, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const counterTierMemberBid = (auctionTierMemberBidId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.put(`${Environment.apiUrl}/Auctions/CounterTierMemberBid/${auctionTierMemberBidId}`, null, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const releaseAuction = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.put(`${Environment.apiUrl}/Auctions/ReleaseAuction/${auctionId}`, null, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getMemberBidCounters = (auctionTierMemberBidId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/GetMemberBidCounters/${auctionTierMemberBidId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addMemberBidCounter = (counterBid, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/AddMemberBidCounter`, counterBid, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addTemplateVehicleAuction = (adminAuctionId, vehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/AddTemplateVehicleAuction/${adminAuctionId}/${vehicleId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const startAuctionTier = (auctionId, auctionTierId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/StartAuctionTier/${auctionId}/${auctionTierId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const expireAuctionTier = (auctionTierId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/ExpireAuctionTier/${auctionTierId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const startAuction = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/StartAuction/${auctionId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const declineCounterBid = (auctionTierMemberBidId, auctionTierMemberBidCounterId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/DeclineCounterBid/${auctionTierMemberBidId}/${auctionTierMemberBidCounterId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const acceptCounterBid = (auctionTierMemberBidId, auctionTierMemberBidCounterId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/AcceptCounterBid/${auctionTierMemberBidId}/${auctionTierMemberBidCounterId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const removeTierMember = (auctionTierMemberId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/RemoveAuctionTierMember/${auctionTierMemberId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getAuction = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/GetAuction/` + auctionId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getCarfaxReports = (vehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/GetCarfaxReports/` + vehicleId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addAuctionNote = (auctionNote, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Auctions/AddAuctionNote`, auctionNote, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getAuctionNotes = (auctionId, publicOnly, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/GetAuctionNotes/` + auctionId + '/' + publicOnly,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const removeAuctionNote = (auctionNoteId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.delete(`${Environment.apiUrl}/Auctions/RemoveAuctionNote/` + auctionNoteId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addAuctionListImpression = (auctionTierMemberId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/AddAuctionListImpression/` + auctionTierMemberId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addAuctionDetailImpression = (auctionTierMemberId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/Auctions/AddAuctionDetailImpression/` + auctionTierMemberId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const AuctionsService =
{
	addAuction,
	getMakes,
	getModels,
	searchAuctions,
	getAuctionVehicle,
	updateAuctionVehicle,
	updateAuction,
	updateAuctionPricing,
	getAuctionTiers,
	getAuctionTierMembers,
	getMemberActiveAuctions,
	getMemberSearchViewModel,
	getBusinessSearchViewModel,
	memberAuctionSearch,
	memberSearchFilters,
	updateAuctionListPricing,
	addMemberBid,
	addMemberBuyNow,
	restartAuction,
	getBidsAndOffersViewModel,
	confirmTierMemberBid,
	counterTierMemberBid,
	releaseAuction,
	getMemberBidCounters,
	addMemberBidCounter,
	addTemplateVehicleAuction,
	startAuctionTier,
	expireAuctionTier,
	startAuction,
	declineCounterBid,
	acceptCounterBid,
	removeTierMember,
	getAuction,
	getCarfaxReports,
	addAuctionNote,
	getAuctionNotes,
	removeAuctionNote,
	cancelAuction,
	addAuctionListImpression,
	addAuctionDetailImpression
}

export default AuctionsService
